module.exports = __webpack_public_path__ + "img/login-calacali.4f013424.svg";